/** Unter dieser Länge (in Zeichen des Suchtexts) wird nicht gesucht — sonst Highlight-Flut. */
export const PROFILE_SEARCH_MIN_LENGTH = 2;

export interface TextMatch {
  start: number;
  end: number;
}

interface FoldedText {
  text: string;
  /** Je Zeichen von `text`: Beginn und Ende des zugehörigen Zeichens im Original. */
  starts: number[];
  ends: number[];
}

function foldChar(char: string): string {
  return char
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/ß/g, 'ss');
}

/**
 * Wie die Suche im ci-select: ohne Groß-/Kleinschreibung und Diakritika (ä=a),
 * dazu ß=ss und zusammengefasste Leerräume. Die Positionen zeigen zurück ins
 * Original, damit der Treffer dort markiert werden kann.
 */
function foldText(source: string): FoldedText {
  let text = '';
  const starts: number[] = [];
  const ends: number[] = [];
  let index = 0;
  for (const char of source) {
    const start = index;
    index += char.length;
    let folded: string;
    if (/\s/.test(char)) {
      if (text.endsWith(' ')) continue;
      folded = ' ';
    } else {
      folded = foldChar(char);
    }
    for (let k = 0; k < folded.length; k++) {
      text += folded[k];
      starts.push(start);
      ends.push(index);
    }
  }
  return {text, starts, ends};
}

/** Liefert den normalisierten Suchbegriff oder `''`, wenn er zu kurz ist. */
export function foldQuery(query: string): string {
  const trimmed = (query ?? '').trim();
  if ([...trimmed].length < PROFILE_SEARCH_MIN_LENGTH) return '';
  return foldText(trimmed).text;
}

/** Nicht überlappende Fundstellen von `foldedQuery` in `source`, als Positionen im Original. */
export function findMatches(source: string, foldedQuery: string): TextMatch[] {
  if (!foldedQuery || !source) return [];
  const folded = foldText(source);
  const matches: TextMatch[] = [];
  let from = 0;
  let idx: number;
  while ((idx = folded.text.indexOf(foldedQuery, from)) !== -1) {
    matches.push({start: folded.starts[idx], end: folded.ends[idx + foldedQuery.length - 1]});
    from = idx + foldedQuery.length;
  }
  return matches;
}

export function countMatches(texts: readonly string[], foldedQuery: string): number {
  return texts.reduce((sum, text) => sum + findMatches(text, foldedQuery).length, 0);
}
